import { useEffect, useState } from "react"
import "./XselAdvantagePanelComponent.scss"
import ShimmerScreen from "../../../Layouts/ShimmerScreen"

const XselAdvantagePanelComponent = () => {

    const [points, setPoints] = useState([])

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/xsel-advantage-points.json`)
        .then(async (response) => {
            const respData = await response.json()
            setPoints(respData)
        })
    }, [])

    return (
        <section className="cardsec">
            <div className="container">
                <h2 className="mgt-4 mgb-4-5">The Xsel advantage</h2>
                <ul className="advantage-cards">
                    {
                        points.length > 0 ?
                        points.map((p, i) => {
                            return (
                                <li className="cardbar" key={i}>
                                    <img src={p.image} alt="" />
                                    <span>{p.title}</span>
                                    <p>{p.description}</p>
                                </li>
                            )
                        })
                        :
                        [1,2,3,4].map((p, i) => {
                            return (
                                <li className="d-flex align-items-center justify-content-center flex-column gap-2" key={i}>
                                    {/* <img src={p.image} alt="" /> */}
                                    <ShimmerScreen 
                                        case="circle"
                                        width="30px"
                                        height="30px"
                                    />
                                    <span>
                                        <ShimmerScreen 
                                            case="rect"
                                            height="1rem"
                                            width="8rem"
                                        />
                                    </span>
                                    <p>
                                        <ShimmerScreen 
                                            case="rect"
                                            height="1rem"
                                            width="12rem"
                                        />
                                    </p>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </section>
    )
}

export default XselAdvantagePanelComponent